import React from "react";
import { Grid, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { AttachmentCard } from "../../../../../components/docCard";
import RightArrowImg from "../../../../../assets/images/icons/rightArrow.svg";
import LeftArrowImg from "../../../../../assets/images/icons/leftArrow.svg";
import { Icon } from "../../../../../components/base";

export const useStyles = makeStyles(() => ({
  container: {
    marginTop: 20,
    border: `1px solid ${COLORS.darks[0][6]}`,
    borderRadius: 8,
    position: "relative",
  },
  arrow: {
    zIndex: 1,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },
}));

export const Portfolio = ({
  portfolioCardData,
  handlePaginate,
  handleBackPaginate,
  prevItemEnable,
  nextItemEnable,
  handleClick,
}) => {
  const classes = useStyles();

  return (
    <ShaDowBox>
      <Grid container className={classes.container}>
        {prevItemEnable && (
          <Icon
            root={classes.arrow}
            src={LeftArrowImg}
            style={{ height: 20, left: -20 }}
            onClick={handleBackPaginate}
            hoverable
          />
        )}
        {portfolioCardData.map((item, i) => (
          <AttachmentCard
            key={i}
            item={item}
            xs={4}
            handleClick={handleClick}
            styles={{
              borderRight: i === 2 ? null : `1px solid ${COLORS.darks[0][6]}`,
              borderTopLeftRadius: !i ? 8 : 0,
              borderBottomLeftRadius: !i ? 8 : 0,
              borderTopRightRadius: i === 2 ? 8 : 0,
              borderBottomRightRadius: i === 2 ? 8 : 0,
            }}
          />
        ))}
        {nextItemEnable && (
          <Icon
            root={classes.arrow}
            src={RightArrowImg}
            style={{ height: 20, right: -20 }}
            onClick={handlePaginate}
            hoverable
          />
        )}
      </Grid>
    </ShaDowBox>
  );
};
